import { inject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

@inject(Element, I18N)
export class KUnitOptionsCustomAttribute {
  private element: HTMLSelectElement;

  constructor(
    element: Element,
    private i18n: I18N,
  ) {
    this.element = element as HTMLSelectElement;
  }

  valueChanged(newValue: string) {
    const type = newValue;
    if (!type)
      throw 'k-unit-options attribute requires a value, e.g. k-unit-options="druck"';

    this.element.options.length = 0;

    let units: any = this.i18n.tr(`units.${type}`, { returnObjects: true });
    for (let key in units) {
      let optionElement = document.createElement("option");
      optionElement.value = key;
      optionElement.text = units[key];
      this.element.options.add(optionElement);
    }
  }
}
